export default "__VITE_ASSET__DMxBwq0J__"